// src/components/FontSelect.jsx
import React from "react";
import { Select, MenuItem, FormControl, InputLabel, Box } from "@mui/material";
import { useData } from "../hooks/useData";
import { FONTS } from "../constants/fonts";

export default function FontSelect({ lineId }) {
  const { lines, updateLine } = useData();
  const line = lines.find((l) => l.id === lineId);

  if (!line) return null;

  const currentFont = FONTS.find((f) => f.name === line.font) || FONTS[0];

  const handleChange = (e) => {
    const fontName = e.target.value;
    updateLine(lineId, { font: fontName });
  };

  return (
    <FormControl
      size="small"
      sx={{
        flex: { xs: "1 1 auto", sm: "1 1 200px" }, // Fills space on mobile, takes share on desktop
        minWidth: { xs: "100%", sm: 160 }, // Full width on mobile, base width on desktop
      }}
    >
      <InputLabel>Font</InputLabel>
      <Select
        value={line.font} // ← guaranteed valid from getDefaultLineValues
        onChange={handleChange}
        label="Font"
        MenuProps={{
          PaperProps: {
            sx: { maxHeight: 300 },
          },
        }}
      >
        {FONTS.map((font) => (
          <MenuItem
            key={font.code}
            value={font.code}
            sx={{
              fontFamily: `'${font.code}', sans-serif`,
              fontSize: "1.1rem",
              fontWeight: 500,
              py: 1,
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              {/* Optional: Add a little preview icon or badge */}
              <Box
                component="span"
                sx={{
                  fontSize: "0.8rem",
                  color: "success.main",
                  opacity: line.font === font.name ? 1 : 0,
                }}
              >
                ●
              </Box>
              {font.name}
            </Box>
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
